module.exports = __webpack_public_path__ + "img/cases-part1-3.0de2d1e1.png";